import { render } from "./LoadingButton.vue?vue&type=template&id=6b123827&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"

import "./LoadingButton.vue?vue&type=style&index=0&id=6b123827&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b123827"]])

export default __exports__